module.exports = __webpack_public_path__ + "media/honey-icons/icon-insights-e04e2973.svg";